import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import TooltipText from "../../../../../components/TooltipText";
import { faEdit, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";

const Acciones = ({ categoria, edit, handleEdit, handleSave, handleCancel, maximos }) => {
  return (
    <div className="d-flex">
      {categoria !== edit ? (
        <Button
          className="d-flex align-items-center ml-2"
          variant="contained"
          onClick={() => handleEdit(categoria, maximos)}
        >
          <FontAwesomeIcon icon={faEdit} size="lg" className="" color="gray" />
        </Button>
      ) : (
        <>
          <TooltipText placement="top" text="Guardar valores" >
            <Button
              className="d-flex align-items-center ml-2"
              variant="contained"
              onClick={() => handleSave(categoria)}
            >
              <FontAwesomeIcon icon={faSave} size="lg" className="" color="#006699" />
            </Button>
          </TooltipText>
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            onClick={() => handleCancel(categoria, maximos)}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="" color="red" />
          </Button>
        </>
      )}
    </div>
  );
};

export default Acciones;
